import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, Phone, MapPin } from 'lucide-react';
import { PawVerseLogo, PawVerseWordmark } from './PawVerseLogo';
export function Footer() {
  return <footer className="bg-primary-900 text-warm-white pt-16 pb-8" data-id="element-49">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-51">
          {/* Brand */}
          <div className="space-y-4" data-id="element-52">
            <Link to="/" className="flex items-center gap-2.5" data-id="element-53">
              <PawVerseLogo size={42} data-id="element-54" />
              <PawVerseWordmark variant="dark" className="text-3xl" data-id="element-55" />
            </Link>
            <p className="font-body text-primary-100 text-sm leading-relaxed" data-id="element-56">
              Pet emergency education platform — from free tips to full
              certification. Online learning and hands-on workshops across the
              Bay Area.
            </p>
            <div className="flex gap-4 pt-2" data-id="element-57">
              <a href="#" className="text-primary-200 hover:text-accent-500 transition-colors" aria-label="Instagram" data-id="element-58">
                <Instagram className="w-5 h-5" data-id="element-59" />
              </a>
              <a href="#" className="text-primary-200 hover:text-accent-500 transition-colors" aria-label="Facebook" data-id="element-60">
                <Facebook className="w-5 h-5" data-id="element-61" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-62">
            <h3 className="font-heading text-xl mb-4 text-accent-500" data-id="element-63">
              Quick Links
            </h3>
            <ul className="space-y-3 font-body text-primary-100 text-sm" data-id="element-64">
              <li data-id="element-65">
                <Link to="/programs" className="hover:text-warm-white transition-colors" data-id="element-66">
                  Programs
                </Link>
              </li>
              <li data-id="element-67">
                <Link to="/workshops" className="hover:text-warm-white transition-colors" data-id="element-68">
                  Workshops
                </Link>
              </li>
              <li data-id="element-69">
                <Link to="/resources" className="hover:text-warm-white transition-colors" data-id="element-70">
                  Free Resources
                </Link>
              </li>
              <li data-id="element-71">
                <Link to="/about" className="hover:text-warm-white transition-colors" data-id="element-72">
                  About
                </Link>
              </li>
              <li data-id="element-73">
                <Link to="/faq" className="hover:text-warm-white transition-colors" data-id="element-74">
                  FAQ
                </Link>
              </li>
              <li data-id="element-75">
                <Link to="/contact" className="hover:text-warm-white transition-colors" data-id="element-76">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div data-id="element-77">
            <h3 className="font-heading text-xl mb-4 text-accent-500" data-id="element-78">
              Service Areas
            </h3>
            <ul className="space-y-3 font-body text-primary-100 text-sm" data-id="element-79">
              <li data-id="element-80">San Jose</li>
              <li data-id="element-81">San Francisco</li>
              <li data-id="element-82">Oakland</li>
              <li data-id="element-83">Palo Alto & Mountain View</li>
              <li data-id="element-84">Sunnyvale & Santa Clara</li>
              <li data-id="element-85">Cupertino</li>
              <li className="pt-2" data-id="element-86">
                <Link to="/workshops" className="text-accent-400 hover:text-accent-300 font-medium transition-colors flex items-center gap-1" data-id="element-87">
                  View full service area <span aria-hidden="true" data-id="element-88">&rarr;</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-89">
            <h3 className="font-heading text-xl mb-4 text-accent-500" data-id="element-90">
              Contact Us
            </h3>
            <ul className="space-y-4 font-body text-primary-100 text-sm" data-id="element-91">
              <li className="flex items-start gap-3" data-id="element-92">
                <Mail className="w-5 h-5 text-accent-500 shrink-0 mt-0.5" data-id="element-93" />
                <a href="mailto:hello@pawverse.com" className="hover:text-warm-white transition-colors" data-id="element-94">
                  hello@pawverse.com
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-95">
                <Phone className="w-5 h-5 text-accent-500 shrink-0 mt-0.5" data-id="element-96" />
                <a href="tel:+14155550198" className="hover:text-warm-white transition-colors" data-id="element-97">
                  (415) 555-0198
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-98">
                <MapPin className="w-5 h-5 text-accent-500 shrink-0 mt-0.5" data-id="element-99" />
                <span data-id="element-100">
                  Based in San Francisco, CA
                  <br data-id="element-101" />
                  Serving the entire Bay Area
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-primary-800 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-102">
          <p className="font-body text-primary-200 text-xs" data-id="element-103">
            &copy; {new Date().getFullYear()} PawVerse Pet Safety Training. All
            rights reserved.
          </p>
          <div className="flex gap-6 font-body text-primary-200 text-xs" data-id="element-104">
            <a href="#" className="hover:text-warm-white transition-colors" data-id="element-105">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-warm-white transition-colors" data-id="element-106">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}